import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import * as actions from "../../store/actions";
import {connect} from "react-redux";
import {Button, TextField} from "@material-ui/core";
import {getFormData, inputChangedHandler, prepareFormData, validateForm} from "../../shared/utility";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {green} from "@material-ui/core/colors";
import PhoneTextField from "../../components/UI/PhoneTextField";
import ImageUploader from "../../components/UI/ImageUploader";
import Avatar from "@material-ui/core/Avatar";
import {Box} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import capitalize from "@material-ui/core/utils/capitalize";
import { ZipFormatter } from '../../shared/formatter';


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute'
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
        textAlign: 'right',

    },
    button: {
        marginLeft: theme.spacing(1),
    },
    avatarWrapper: {
        display: "flex",
        flexDirection: "column",
        verticalAlign: 'middle'
    },
    avatar: {
        background: theme.palette.primary.main,
        color: "white",
        fontWeight: "bold",
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
    imageUploader: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
    },
    title: {
        fontSize: '24px'
    }


}));


let formData = {
    controls: {
        avatar: {
            value: '',
            valid: true,
        },
        avatarBase64: {
            value: '',
            valid: true,
        },
        firstName: {
            label: 'First name'.toUpperCase(),
            value: '',
            validation: { presence: {allowEmpty: false}, length: { minimum: 2 } },
            valid: false,
            touched: false,
            helperText: null,
        },
        lastName: {
            label: 'Last name'.toUpperCase(),
            value: '',
            validation: { presence: {allowEmpty: false}, length: { minimum: 2 } },
            valid: false,
            touched: false,
            helperText: null,
        },
        email: {
            label: 'Email Address'.toUpperCase(),
            value: '',
            validation: {presence: {allowEmpty: false}, email: true},
            valid: false,
            touched: false,
            helperText: null,
        },
        phone: {
            label: 'Phone number'.toUpperCase(),
            value: '',
            mask: '(999) 999-9999',
            validation: {
                presence: { message: 'can\'t be blank', allowEmpty: false },
                length: { minimum: 10, message: 'can\'t be less than 10 digits' },
                format: { pattern: '\\(\\d{3}\\)\\s\\d{3}-\\d{4}|\\d{10}', message: 'cant\'t be less than 10 digits' }
            },
            valid: false,
            touched: false,
            helperText: null,
        },

        zip: {
            label: 'Zip Code'.toUpperCase(),
            value: '',
            validation: {length: {minimum: 1, maximum: 5, allowEmpty: false}},
            inputFilter: '[^0-9]',
            valid: true,
            touched: false,
            helperText: null,
        },

    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}


const Account = (props) => {

    const classes = useStyles();
    const avatar = React.useRef(null);
    const history = useHistory();
    formData = prepareFormData(formData, props.account);
    formData.controls.phone.value = formData.controls.phone.value.replace('+1', '')

    const [formState, setFormState] = useState(formData);
    const [loading, setLoading] = useState(false);

    const avatarField = formState.controls.avatar;
    const avatarBase64Field = formState.controls.avatarBase64;
    const firstNameField = formState.controls.firstName;
    const lastNameField = formState.controls.lastName;
    const emailField = formState.controls.email;
    const phoneField = formState.controls.phone;
    const zipField = formState.controls.zip;
    const submitHandler = async (event) => {
        event.preventDefault();
        props.clearAppMessage();
        if (validateForm(formState, setFormState)) {
            zipField.value = ZipFormatter.format(zipField.value);
            setFormState(formState);
            const data = getFormData(formState)
            data.phone = '+1' + data.phone
            setLoading(true);
            props.onSaveAccount(data, (err, params) => {
                setLoading(false);
                if (err) {
                    return ;
                }
                history.push('/dashboard');
            });
        }
    }

    return (
        <React.Fragment>
            <h1 className={classes.title}>Account Profile</h1>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div className={classes.avatarWrapper}>
                    <Box display="flex" p={1}>
                        <Box>
                            <Avatar className={classes.avatar} ref={avatar}
                                    src={avatarBase64Field.value ? avatarBase64Field.value : avatarField.value}>{(props.account && props.account.firstName) ? capitalize(props.account.firstName).charAt(0) : "D"}</Avatar>
                        </Box>
                        <Box className={classes.imageUploader}><ImageUploader formState={formState}
                                                                              setFormState={setFormState}
                                                                              datakey={avatarBase64Field.key}/></Box>
                    </Box>


                </div>
                <div>
                    <TextField
                        name={firstNameField.key}
                        value={firstNameField.value}
                        type='input'
                        label={firstNameField.label}
                        placeholder={firstNameField.label}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, firstNameField.key)}
                        helperText={firstNameField.helperText}
                        error={!firstNameField.valid && firstNameField.touched}

                    />
                </div>
                <div>
                    <TextField
                        name={lastNameField.key}
                        value={lastNameField.value}
                        type='input'
                        label={lastNameField.label}
                        placeholder={lastNameField.label}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, lastNameField.key)}
                        helperText={lastNameField.helperText}
                        error={!lastNameField.valid && lastNameField.touched}

                    />
                </div>
                <div>
                    <TextField
                        name={emailField.key}
                        value={emailField.value}
                        type='input'
                        label={emailField.label}
                        placeholder={emailField.label}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, emailField.key)}
                        helperText={emailField.helperText}
                        error={!emailField.valid && emailField.touched}

                    />

                </div>
                <div>
                    <PhoneTextField
                        name={phoneField.key}
                        mask={phoneField.mask}
                        value={phoneField.value}
                        type='input'
                        label={phoneField.label}
                        placeholder={phoneField.label}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, phoneField.key)}
                        helperText={phoneField.helperText}
                        error={!phoneField.valid && phoneField.touched}

                    />

                </div>

                <div>
                    <TextField
                        name={zipField.key}
                        value={zipField.value}
                        type='input'
                        label={zipField.label}
                        inputProps={{ maxLength: zipField.validation.length.maximum }}
                        placeholder={zipField.label}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, zipField.key)}
                        helperText={zipField.helperText}
                        error={!zipField.valid && zipField.touched}

                    />

                </div>

                {props.error &&
                <div className={`$classes.wrapper `}>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }

                <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                    {/* <StyledButton
                        buttonProps={{
                            variant: "outlined",

                            onClick: () => {
                                history.push('/dashboard')
                            },
                            className: classes.button
                        }}
                        label={'Cancel'}
                    />

                    <StyledButton
                        buttonProps={{
                            variant: "contained",
                            color: "primary",
                            onClick: submitHandler,
                            className: classes.button,
                            disabled: loading
                        }}
                        label={'Save'}
                    />
                    {loading && <CircularProgress size={24} className={classes.buttonProgress}/>} */}

                    <div className={classes.wrapper}>
                        <Button className={classes.button} type={"button"} variant={"outlined"} onClick={() => {
                            history.push('/dashboard')
                        }}
                        > Cancel</Button>

                        <Button className={classes.button} type={"button"} variant={"contained"} color={"primary"}
                                disabled={loading}
                                onClick={submitHandler}
                        > {loading &&
                        <CircularProgress size={30} className={classes.buttonProgress} color="secondary"/>} Save</Button>

                    </div>
                </Box>
            </form>
        </React.Fragment>

    );
}

const mapStateToProps = state => {
    return {
        account: state.account
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSaveAccount: (account, cb) => dispatch(actions.setAccount(account, cb)),
        clearAppMessage: () => dispatch(actions.setAppStateMessage(null))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);